import { Dispatch } from 'react-redux';
import { ContractErrorState } from './contract-error.reducer';
import { requestAction } from '@common/components/common.actions';
import { Action } from 'redux';
import { ContractErrorViewModel } from '@models/ContractError';
import { PageViewModel } from '../_models/common.models';
import { contractService } from '@services/ContractService';

export enum ContractErrorActionType {
  SetIsLoading = 'SetIsLoading',
  SetContractErrorQuery = 'SetContractErrorQuery',
  SetContractErrorList = 'SetContractErrorList'
}

export interface SetIsLoadingAction extends Action {
  readonly type: ContractErrorActionType.SetIsLoading;
  readonly isLoading: boolean;
}

export function setIsLoading(loading: boolean): SetIsLoadingAction {
  return {
    type: ContractErrorActionType.SetIsLoading,
    isLoading: loading
  };
}

export interface SetContractErrorQueryAction extends Action {
  readonly type: ContractErrorActionType.SetContractErrorQuery;
  readonly query: string | null;
  readonly orderBy: string;
  readonly orderDirection: string;
}

export function setContractErrorQuery(
  query: string | null,
  orderBy: string,
  orderDirection: string
): SetContractErrorQueryAction {
  return {
    type: ContractErrorActionType.SetContractErrorQuery,
    query: query,
    orderBy: orderBy,
    orderDirection: orderDirection
  };
}

export interface SetContractErrorListAction extends Action {
  readonly type: ContractErrorActionType.SetContractErrorList;
  readonly contractErrorList: Array<ContractErrorViewModel>;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly totalResults: number;
}

export function setContractErrorList(result: PageViewModel<ContractErrorViewModel>): SetContractErrorListAction {
  return {
    type: ContractErrorActionType.SetContractErrorList,
    contractErrorList: result.results,
    pageNumber: result.page,
    pageSize: result.pageSize,
    totalResults: result.totalResults
  };
}

export function searchContractError(pageNumber: number, pageSize: number, orderBy: string, orderDirection: string) {
  return async (dispatch: Dispatch<ContractErrorState>) => {
    // dispatch(setContractErrorQuery(query, orderBy, orderDirection));
    return dispatch(
      requestAction(
        () => contractService.contractErrorSearch(pageNumber, pageSize, orderBy, orderDirection),
        setContractErrorList
      )
    );
  };
}

export function completeContractError(contractErrorId: number, completeDate: Date) {
  return async (dispatch: Dispatch<ContractErrorState>) => {
    // dispatch(setContractErrorQuery(query, orderBy, orderDirection));
    return dispatch(
      requestAction(
        () => contractService.contractErrorComplete(contractErrorId, completeDate),
        () => {
          return {
            type: ''
          };
        }
      )
    );
  };
}



// WEBPACK FOOTER //
// ./src/contract-error/contract-error.actions.tsx